'use client'

import { createContext, useContext } from 'react'
import { createPortal } from 'react-dom'
import { X } from 'lucide-react'

// Context for the container element to portal sheets into
export const ContainerContext = createContext<HTMLDivElement | null>(null)

interface InlineSheetProps {
  open: boolean
  onClose: () => void
  children: React.ReactNode
  title: string
  description?: string
}

export function InlineSheet({ open, onClose, children, title, description }: InlineSheetProps) {
  const container = useContext(ContainerContext)

  if (!open || !container) return null

  return createPortal(
    <div className="absolute inset-0 z-50 flex flex-col bg-zinc-900/95 backdrop-blur-sm animate-in slide-in-from-bottom duration-300">
      {/* Header */}
      <div className="shrink-0 flex items-center justify-between px-4 py-3 border-b border-zinc-800">
        <div>
          <h3 className="font-semibold text-white">{title}</h3>
          {description && <p className="text-xs text-zinc-400">{description}</p>}
        </div>
        <button
          onClick={onClose}
          className="p-2 hover:bg-zinc-800 rounded-full transition-colors"
        >
          <X className="h-5 w-5 text-zinc-400" />
        </button>
      </div>
      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        {children}
      </div>
    </div>,
    container
  )
}
